import { css } from '@emotion/core';
import colors from '../../../../../styles/colors';

export const profileViewWrapper = css`
  grid-column: midSide / rightSide;
  grid-row: sub2 / bottom;
  overflow-y: auto;
  background-color: ${colors.white};

  .chakra-ui-dark & {
    background-color: ${colors.black};
  }
`;
